export default "__VITE_ASSET__ce0e5bfb__$_?nuxt_component=async__"